// // API Configuration - Centralized API Caller
// // Easy to switch between localhost and production

// // Set this to true for local development, false for production
// const USE_LOCAL_API = true;

// // API Base URLs
// const API_CONFIG = {
//   local: 'http://localhost:8080',
//   production: 'https://www.mbascribbles.com:8443'
// };

// // Get the base URL based on environment
// const getBaseURL = () => {
//   return USE_LOCAL_API ? API_CONFIG.local : API_CONFIG.production;
// };

// // Generic fetch wrapper with error handling
// const apiCall = async (endpoint, options = {}) => {
//   const url = `${getBaseURL()}${endpoint}`;
  
//   console.log(`[API Call] ${options.method || 'GET'} ${url}`);
  
//   try {
//     const response = await fetch(url, {
//       ...options,
//       headers: {
//         'Accept': 'application/json',
//         ...options.headers,
//       },
//     });

//     console.log(`[API Response] Status: ${response.status}`);

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error(`[API Error] ${response.status}: ${errorText}`);
//       throw new Error(errorText || `HTTP ${response.status}`);
//     }

//     const data = await response.json().catch(() => response.text());
//     return { success: true, data, status: response.status };
//   } catch (error) {
//     console.error(`[API Exception]`, error.message);
//     return { success: false, error: error.message, status: null };
//   }
// };

// // API Methods
// export const API = {
//   // User endpoints
//   addUser: (name, email, country, phoneNo, password) => {
//     const url = new URL(`${getBaseURL()}/users/add`);
//     url.searchParams.append('name', name);
//     url.searchParams.append('email', email);
//     url.searchParams.append('country', country);
//     url.searchParams.append('phoneNo', phoneNo);
//     url.searchParams.append('password', password);

//     return fetch(url.toString(), {
//       method: 'POST',
//       headers: {
//         'Accept': 'application/json',
//       },
//     }).then(res => {
//       if (!res.ok) {
//         return res.text().then(text => {
//           throw new Error(text);
//         });
//       }
//       return res.text();
//     }).catch(error => {
//       throw error;
//     });
//   },

//   getUsers: () => apiCall('/users', { method: 'GET' }),

//   testBackend: () => apiCall('/test-backend', { method: 'GET' }),

//   testDatabase: () => apiCall('/test-db', { method: 'GET' }),

//   // Courses endpoints
//   getCourses: () => apiCall('/courses', { method: 'GET' }),

//   addCourse: (courseData) => apiCall('/AddCourse', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(courseData),
//   }),

//   // Subjects endpoints
//   getSubjects: () => apiCall('/subject', { method: 'GET' }),

//   addSubject: (subjectData) => apiCall('/addSubject', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(subjectData),
//   }),

//   // Documents endpoints
//   getDocuments: () => apiCall('/documents', { method: 'GET' }),

//   // Payment endpoints
//   checkout: (paymentData) => apiCall('/checkOut', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(paymentData),
//   }),

//   getPaymentStatus: (orderId) => apiCall(`/status?orderId=${encodeURIComponent(orderId)}`, { method: 'GET' }),

//   validateCoupon: (couponCode) => apiCall(`/validate?coupon=${encodeURIComponent(couponCode)}`, { method: 'GET' }),

//   updateUser: (userUpdateData) => apiCall('/updateUser', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(userUpdateData),
//   }),

//   uploadNote: (noteData, formData) => apiCall('/uploadNote', {
//     method: 'POST',
//     body: formData,
//   }),

//   getMyLearnings: () => apiCall('/myLearnings', { method: 'GET' }),

//   validateSession: () => apiCall('/validate-session', { method: 'GET' }),

//   logout: () => apiCall('/out', { method: 'POST' }),

//   downloadFile: (fileName) => apiCall(`/download/${encodeURIComponent(fileName)}`, { method: 'GET' }),

//   // Login endpoint
//   login: (email, password) => {
//     const url = new URL(`${getBaseURL()}/login`);
//     url.searchParams.append('email', email);
//     url.searchParams.append('password', password);
//     return fetch(url.toString(), { 
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       }
//     });
//   },

//   // Generic method for any endpoint
//   call: (endpoint, method = 'GET', body = null) => {
//     const options = { method };
//     if (body) {
//       options.headers = { 'Content-Type': 'application/json' };
//       options.body = JSON.stringify(body);
//     }
//     return apiCall(endpoint, options);
//   },
// };

// // Helper to toggle between local and production
// export const setAPIEnvironment = (isLocal) => {
//   console.log(`API Environment switched to: ${isLocal ? 'LOCAL' : 'PRODUCTION'}`);
//   // This would require restructuring to make USE_LOCAL_API dynamic
//   // For now, edit the USE_LOCAL_API constant directly
// };

// export default API;


// API Configuration - Centralized API Caller
// Easy to switch between localhost and production

// Set this to true for local development, false for production
const USE_LOCAL_API = false;

// API Base URLs
const API_CONFIG = {
  local: 'http://localhost:8080',
  production: 'https://backend.mbascribbles.in'
};

// Get the base URL based on environment
const getBaseURL = () => {
  return USE_LOCAL_API ? API_CONFIG.local : API_CONFIG.production;
};

// Generic fetch wrapper with error handling
const apiCall = async (endpoint, options = {}) => {
  const url = `${getBaseURL()}${endpoint}`;
  
  console.log(`[API Call] ${options.method || 'GET'} ${url}`);
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Accept': 'application/json',
        ...options.headers,
      },
    });

    console.log(`[API Response] Status: ${response.status}`);

    // Read response body ONCE
    const contentType = response.headers.get('content-type');
    let data;
    
    try {
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = await response.text();
      }
    } catch (parseError) {
      data = null;
    }

    // Check if response was successful
    if (!response.ok) {
      console.error(`[API Error] ${response.status}:`, data);
      return { 
        success: false, 
        error: data?.message || data?.error || data || `HTTP ${response.status}`,
        data: data,
        status: response.status 
      };
    }

    return { success: true, data, status: response.status };
  } catch (error) {
    console.error(`[API Exception]`, error.message);
    return { success: false, error: error.message, status: null };
  }
};

// API Methods
export const API = {
  // User endpoints
  addUser: (name, email, country, phoneNo, password) => {
    const url = new URL(`${getBaseURL()}/users/add`);
    url.searchParams.append('name', name);
    url.searchParams.append('email', email);
    url.searchParams.append('country', country);
    url.searchParams.append('phoneNo', phoneNo);
    url.searchParams.append('password', password);

    return fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      },
    }).then(res => {
      if (!res.ok) {
        return res.text().then(text => {
          throw new Error(text);
        });
      }
      return res.text();
    }).catch(error => {
      throw error;
    });
  },

  getUsers: () => apiCall('/users', { method: 'GET' }),

  testBackend: () => apiCall('/test-backend', { method: 'GET' }),

  testDatabase: () => apiCall('/test-db', { method: 'GET' }),

  // Courses endpoints
  getCourses: () => apiCall('/courses', { method: 'GET' }),

  addCourse: (courseData) => apiCall('/AddCourse', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(courseData),
  }),

  // Subjects endpoints
  getSubjects: () => apiCall('/subject', { method: 'GET' }),

  addSubject: (subjectData) => apiCall('/addSubject', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subjectData),
  }),

  // Documents endpoints
  getDocuments: () => apiCall('/documents', { method: 'GET' }),

  // Payment endpoints
  checkout: (paymentData) => apiCall('/checkOut', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  }),

  getPaymentStatus: (orderId) => apiCall(`/status?orderId=${encodeURIComponent(orderId)}`, { method: 'GET' }),

  validateCoupon: (couponCode) => apiCall(`/validate?coupon=${encodeURIComponent(couponCode)}`, { method: 'GET' }),

  updateUser: (userUpdateData) => apiCall('/updateUser', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userUpdateData),
  }),

  uploadNote: (noteData, formData) => apiCall('/uploadNote', {
    method: 'POST',
    body: formData,
  }),

  getMyLearnings: () => apiCall('/myLearnings', { method: 'GET' }),

  validateSession: () => apiCall('/validate-session', { method: 'GET' }),

  logout: () => apiCall('/out', { method: 'POST' }),

  // downloadFile: (fileName) => apiCall(`/download/${encodeURIComponent(fileName)}`, { method: 'GET' }),

  downloadFile: async (fileName) => {
    try {
      console.log('[API] Downloading file:', fileName);
      const encodedFileName = encodeURIComponent(fileName);
      const response = await fetch(
        `https://backend.mbascribbles.in/download/${encodedFileName}`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/pdf',
          },
        }
      );

      console.log('[API] Response status:', response.status);
      console.log('[API] Response headers:', response.headers);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the response as a blob
      const blob = await response.blob();
      console.log('[API] Blob created:', blob.size, 'bytes, type:', blob.type);
      
      // Verify it's a PDF
      if (blob.type !== 'application/pdf' && !blob.type.includes('pdf')) {
        console.warn('[API] Response is not a PDF:', blob.type);
        // Force the type to be PDF
        return {
          success: true,
          data: new Blob([blob], { type: 'application/pdf' })
        };
      }

      return {
        success: true,
        data: blob
      };
    } catch (error) {
      console.error('[API] Error downloading file:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Login endpoint
  login: (email, password) => {
    const url = new URL(`${getBaseURL()}/login`);
    url.searchParams.append('email', email);
    url.searchParams.append('password', password);
    return fetch(url.toString(), { 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },

  // Generic method for any endpoint
  call: (endpoint, method = 'GET', body = null) => {
    const options = { method };
    if (body) {
      options.headers = { 'Content-Type': 'application/json' };
      options.body = JSON.stringify(body);
    }
    return apiCall(endpoint, options);
  },
};

// Helper to toggle between local and production
export const setAPIEnvironment = (isLocal) => {
  console.log(`API Environment switched to: ${isLocal ? 'LOCAL' : 'PRODUCTION'}`);
  // This would require restructuring to make USE_LOCAL_API dynamic
  // For now, edit the USE_LOCAL_API constant directly
};

export default API;